module.exports = __webpack_public_path__ + "static/pitch-sans-semibold-42c6cc9c4ef8e98c5691233315845d16.woff2";